import React, {Component} from 'react'
import {FormattedDate, FormattedMessage} from 'react-intl'
import Icon from "../common/icon/icon.component.jsx";

class InvoiceStatusTimeLine extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            invoice: this.props.invoice || null,
            className: this.props.className || '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            invoice: nextProps.invoice || null,
        })
    }

    render() {

        const step3 = {
            disabled: true,
            icon: 'circle',
            iconClass: '',
            text: <FormattedMessage
                id="invoice.edit.workflow.no_payment_label"
                defaultMessage="No payment"
            />
        }
        const step4 = {
            disabled: true,
            icon: 'circle',
            iconClass: '',
            text: <FormattedMessage
                id="invoice.edit.workflow.not_paid_label"
                defaultMessage="Not fully paid"
            />
        }


        let currentStep = {
            disabled: false,
            icon: 'check-circle',
            iconClass: '',
            text: <FormattedMessage
                id="invoice.edit.workflow.sent_on_label"
                defaultMessage="Sent on {date}"
                values={{
                    date: <FormattedDate
                        year='numeric'
                        month='long'
                        day='numeric'
                        value={new Date(this.state.invoice.attributes.sentAt)}/>
                }}
            />
        }

        if (this.state.invoice.attributes.lastPaymentAt) {
            if (this.state.invoice.attributes.status === 'fully-paid') {
                step3.disabled = false
                step3.icon = 'check-circle'
                step3.text = <FormattedMessage
                    id="invoice.edit.workflow.number_payment_label"
                    defaultMessage="{number, plural, one {# payment} other {# payments}}"
                    values={{
                        number: this.state.invoice.attributes.paymentTransactions.length
                    }}
                />
            } else {
                step3.disabled = false
                step3.icon = 'check-circle'
                step3.text = <FormattedMessage
                    id="invoice.edit.workflow.partially_paid_on_label"
                    defaultMessage="Partially paid on {date}"
                    values={{
                        date: <FormattedDate
                            year='numeric'
                            month='long'
                            day='numeric'
                            value={new Date(this.state.invoice.attributes.lastPaymentAt)}/>
                    }}
                />
            }
        }

        if (this.state.invoice.attributes.fullyPaidAt) {
            step4.disabled = false
            step4.icon = 'check-circle'
            step4.text = <FormattedMessage
                id="invoice.edit.workflow.fully_paid_on_label"
                defaultMessage="Fully paid on {date}"
                values={{
                    date: <FormattedDate
                        year='numeric'
                        month='long'
                        day='numeric'
                        value={new Date(this.state.invoice.attributes.fullyPaidAt)}/>
                }}
            />
        }
        if (this.state.invoice.attributes.voidedAt) {
            step4.disabled = false
            step4.icon = 'times-circle'
            step4.text = <FormattedMessage
                id="invoice.edit.workflow.voided_on_label"
                defaultMessage="Voided on {date}"
                values={{
                    date: <FormattedDate
                        year='numeric'
                        month='long'
                        day='numeric'
                        value={new Date(this.state.invoice.attributes.voidedAt)}/>
                }}
            />
            if (!this.state.invoice.attributes.lastPaymentAt) {
                step3.disabled = false
                step3.icon = 'circle'
            }
        }


        if (!step3.disabled) {
            currentStep = step3
        }
        if (!step4.disabled) {
            currentStep = step4
        }

        return <div className={"row " + this.state.className}>
            <div className="col-12">
                <div className={"row px-3"}>
                    <div className={"col-3 p-0 d-none d-md-block"}>
                        <div className={"row"}>
                            <div className={"col-12 d-flex align-items-center"}>
                                <div className={"flex-fill"}> </div>
                                <Icon className={"px-2 workflow-icon"} value={"check-circle"}/>
                                <div className={"flex-fill"}><hr className={"workflow-line"} /></div>
                            </div>
                            <div className={"col-12 text-center"}>
                                <FormattedMessage
                                    id="invoice.edit.workflow.created_on_label"
                                    defaultMessage="Created on {date}"
                                    values={{
                                        date: <FormattedDate
                                            year='numeric'
                                            month='long'
                                            day='numeric'
                                            value={new Date(this.state.invoice.attributes.createdAt)}/>
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={"col-3 p-0 d-none d-md-block"}>
                        <div className={"row"}>
                            <div className={"col-12 d-flex align-items-center"}>
                                <div className={"flex-fill"}><hr className={"workflow-line"} /></div>
                                <Icon className={"px-2 workflow-icon"} value={"check-circle"}/>
                                <div className={"flex-fill"}><hr className={"workflow-line"} /></div>
                            </div>
                            <div className={"col-12 text-center"}>
                                <FormattedMessage
                                    id="invoice.edit.workflow.sent_on_label"
                                    defaultMessage="Sent on {date}"
                                    values={{
                                        date: <FormattedDate
                                            year='numeric'
                                            month='long'
                                            day='numeric'
                                            value={new Date(this.state.invoice.attributes.sentAt)}/>
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={"col-3 p-0 d-none d-md-block"}>
                        <div className={"row"}>
                            <div className={"col-12 d-flex align-items-center"}>
                                <div className={"flex-fill"}><hr className={"workflow-line " + (step3.disabled ? 'disabled' : '')} /></div>
                                <Icon className={"px-2 workflow-icon " + step3.iconClass + (step3.disabled ? ' disabled' : '')} value={step3.icon}/>
                                <div className={"flex-fill"}><hr className={"workflow-line " + (step3.disabled ? 'disabled' : '')} /></div>
                            </div>
                            <div className={"col-12 text-center"}>
                                {step3.text}
                            </div>
                        </div>
                    </div>
                    <div className={"col-3 p-0 d-none d-md-block"}>
                        <div className={"row"}>
                            <div className={"col-12 d-flex align-items-center"}>
                                <div className={"flex-fill"}><hr className={"workflow-line " + (step4.disabled ? 'disabled' : '')} /></div>
                                <Icon className={"px-2 workflow-icon "+ step4.iconClass + (step4.disabled ? ' disabled' : '')} value={step4.icon}/>
                                <div className={"flex-fill"}> </div>
                            </div>
                            <div className={"col-12 text-center"}>
                                {step4.text}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"row px-3 d-block d-md-none"}>
                    <div className={"col-12 p-0"}>
                        <div className={"row"}>
                            <div className={"col-12 d-flex justify-content-center"}>
                                <Icon className={"px-2 workflow-icon "+ currentStep.iconClass + (currentStep.disabled ? ' disabled' : '')} value={currentStep.icon}/>
                            </div>
                            <div className={"col-12 text-center"}>
                                {currentStep.text}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

}

export default InvoiceStatusTimeLine





// WEBPACK FOOTER //
// ./src/invoice/statustimeline.component.jsx